import React from 'react';

import { Skeleton } from '@mui/material';

import { en } from 'localization';
import {
  PublicContainer,
  PublicFooter,
  PublicMain,
  PublicPageShell,
  PublicSiteHeader,
} from 'shared-components/public-shell';
import { VisuallyHidden } from 'shared-components/state-views';

import { HeroCtaCluster, HeroSection, HeroTop } from './styled-components';

const copy = en.publicLanding;

// The / route's Suspense fallback so the chunk download reads as one branded
// skeleton, never a bare spinner. The header's Open roles CTA is hidden because
// this is a transient pre-mount placeholder with no scroll-reveal of its own.
export const LandingLoading: React.FC = () => (
  <PublicPageShell>
    <PublicSiteHeader openRoles="hide" />

    <PublicMain>
      <HeroSection
        aria-busy="true"
        aria-label={copy.loadingLabel}
        role="status"
      >
        <PublicContainer>
          <VisuallyHidden>{copy.loadingLabel}</VisuallyHidden>

          <Skeleton aria-hidden variant="text" width="14rem" />

          <HeroTop>
            <Skeleton
              aria-hidden
              height="4.5rem"
              variant="text"
              width="min(20ch, 100%)"
            />

            <HeroCtaCluster>
              <Skeleton
                aria-hidden
                height="3.25rem"
                variant="rounded"
                width="13rem"
              />
            </HeroCtaCluster>
          </HeroTop>

          <Skeleton aria-hidden variant="text" width="90%" />

          <Skeleton aria-hidden variant="text" width="60%" />
        </PublicContainer>
      </HeroSection>
    </PublicMain>

    <PublicFooter />
  </PublicPageShell>
);

export default LandingLoading;
